import { voorwaardenSelectieSchema } from "../infra/hypotheek-schema";
import { HypothekenState } from "../infra/hypotheek-types";
import { HypotheekVergelijkenSchemaContextType } from "./hypotheek-vergelijken-modal";
import { hypotheekVergelijkenSchema } from "./hypotheek-vergelijken-schema";
import { HypotheekVergelijkenModalType } from "./hypotheek-vergelijken-types";

export const newHypotheekVergelijkenModalFactory = (hypotheek: HypothekenState): HypotheekVergelijkenModalType => {
  return {
    ...hypotheekVergelijkenSchema.default(),
    aanvangsDatum: hypotheek.aanvangsdatum,
    hypotheekSamenstelling: hypotheek.producten,
    panden: hypotheek.panden,
    modalOpen: true,
    fiscaleVoortzettingKeuzes: hypotheek.fiscaleVoortzettingKeuzes,
    energieKlasse: hypotheek.energieKlasse,
    meerwerkEBV: hypotheek.meerwerkEBV,
    soortFinanciering: hypotheek.soortFinanciering,
    aanvrager1: hypotheek.aanvrager1,
    aanvrager2: hypotheek.aanvrager2,
    voorwaardeSelectie: {
      ...voorwaardenSelectieSchema.default(),
      verklaringInkomen: hypotheek.voorwaardenSelectie?.verklaringInkomen ?? null
    },
    nhg: hypotheek.nhg,
    eigenwoningschuldBedrag: hypotheek.eigenwoningschuldBedrag,
    gewensteHypotheekBedrag: hypotheek.gewensteHypotheek
  };
};

export const checkTotalen = (
  values: HypotheekVergelijkenModalType,
  checkLager = false
): HypotheekVergelijkenSchemaContextType => {
  const result: HypotheekVergelijkenSchemaContextType = {
    somLeningdelenHoofdsomTotaalError: false
  };
  values.panden.forEach(pand => {
    const totaalLeningdelen = values.hypotheekSamenstelling
      .map(e => e.leningdeelgegevens.leningdeelHoofdsom.bedrag || 0)
      .reduce((a, b) => a + b, 0);
    if (
      (pand.totaleHypotheekBedrag && totaalLeningdelen > pand.totaleHypotheekBedrag) ||
      (checkLager && pand.totaleHypotheekBedrag && totaalLeningdelen < pand.totaleHypotheekBedrag)
    ) {
      result.somLeningdelenHoofdsomTotaalError = true;
    }
  });
  return result;
};
